export default __webpack_public_path__ + "static/media/msn300.7ae402ac.png";